import internalHttp from "../utility/internal-http";

const BASE = "/internal/v1/reports";

const ListStates = async () => internalHttp.get(`${BASE}/states`, true);

const ListCities = async (stateId) =>
  internalHttp.get(`${BASE}/cities?stateId=${encodeURIComponent(stateId)}`, true);

const ListFields = async () => internalHttp.get(`${BASE}/fields`, true);

const ListTransferRequests = async ({
  page = 1,
  limit = 50,
  reportBase = "branch",
  stateId,
  cityId,
  dateFrom,
  dateTo,
  keyword,
  sortBy,
  sortOrder,
  excludeBranchIds,
} = {}) => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (reportBase) params.set("reportBase", reportBase);
  if (stateId) params.set("stateId", String(stateId));
  if (reportBase !== "patient" && cityId) params.set("cityId", String(cityId));
  if (dateFrom) params.set("dateFrom", dateFrom);
  if (dateTo) params.set("dateTo", dateTo);
  if (keyword) params.set("keyword", keyword);
  if (sortBy) params.set("sortBy", sortBy);
  if (sortOrder) params.set("sortOrder", sortOrder);
  if (excludeBranchIds?.length) {
    const ids = Array.isArray(excludeBranchIds) ? excludeBranchIds : [excludeBranchIds];
    params.set("excludeBranchIds", ids.filter(Boolean).join(","));
  }
  return internalHttp.get(`${BASE}/transfer-requests?${params.toString()}`, true);
};

const ExportTransferRequests = async (payload) =>
  internalHttp.post(`${BASE}/transfer-requests/export`, payload, { silent: true });

const adminReportsService = {
  ListStates,
  ListCities,
  ListFields,
  ListTransferRequests,
  ExportTransferRequests,
};

export default adminReportsService;
